import get from 'lodash/get';
import session from '@flowio/session';

export function getCustomerTokenId() {
  return get(session.getAttributes(), 'flow_consumer_id');
}

export function getCustomerToken(customerTokenValue) {
  const customerTokenId = getCustomerTokenId();

  if (customerTokenValue) {
    return {
      discriminator: 'customer_token',
      value: customerTokenValue,
    };
  }

  if (customerTokenId) {
    return {
      discriminator: 'legacy_customer_token',
      value: getCustomerTokenId(),
    };
  }

  return undefined;
}



// WEBPACK FOOTER //
// ./static/js/v0/utilities/customer-tokens.js